/**
 * Returns a function that creates an array of tuples with the given size.
 *
 * @param {number} size - The size of the tuple.
 * @returns {Function<T[], T[size][]>} A function that takes an array and returns an array of tuples.
 */
export const groupTuples =
  <T>(size: number) =>
  (items: T[]): T[][] => {
    const tuples = [];
    let tuple = [];

    for (let i = 0; i < items.length; i++) {
      tuple.push(items[i]);

      if ((i + 1) % size == 0) {
        tuples.push(tuple);
        tuple = [];
      }
    }

    if (tuple.length > 0) {
      tuples.push(tuple);
    }

    return tuples;
  };
